import { render, staticRenderFns } from "./PresentationNew.vue?vue&type=template&id=5d04b524"
import script from "./PresentationNew.vue?vue&type=script&lang=js"
export * from "./PresentationNew.vue?vue&type=script&lang=js"
import style0 from "./PresentationNew.vue?vue&type=style&index=0&id=5d04b524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports